import styled from 'styled-components'

export const FotoPerfil = styled.img`
  width: 128px;
  heigth: 128px;
  border-radius: 50%;
  margin-bottom: 24px;
`
